module.exports = __webpack_public_path__ + "img/palmar-spa-2.c9fbae1e.jpg";